var _circle, _g, _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _path3, _path4, _rect7, _rect8, _rect9, _path5, _path6, _rect0, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 110,
    r: 110,
    fill: "#E6F1FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5261_46783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 46C53 43.7909 54.7909 42 57 42H163C165.209 42 167 43.7909 167 46V174C167 176.209 165.209 178 163 178H57C54.7909 178 53 176.209 53 174V46Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 57.5,
    width: 28,
    height: 28,
    rx: 4,
    fill: "#C7DDF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 79.5C86.4183 79.5 90 75.9183 90 71.5C90 67.0817 86.4183 63.5 82 63.5C77.5817 63.5 74 67.0817 74 71.5C74 75.9183 77.5817 79.5 82 79.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85 67.5L79 75.5",
    stroke: "#C7DDF7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 64.5,
    width: 46,
    height: 5,
    rx: 2.5,
    fill: "#E3E6EA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 75.5,
    width: 34,
    height: 5,
    rx: 2.5,
    fill: "#E3E6EA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 95.5,
    width: 28,
    height: 28,
    rx: 4,
    fill: "#C7DDF7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 102.5,
    width: 46,
    height: 5,
    rx: 2.5,
    fill: "#E3E6EA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 113.5,
    width: 34,
    height: 5,
    rx: 2.5,
    fill: "#E3E6EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1875 101.968C82.7485 99.8469 85.7836 99.3651 87.9666 100.892C90.1497 102.418 90.6541 105.376 89.0931 107.497L85.9528 111.764L82.8125 116.031C81.2515 118.152 78.2164 118.634 76.0334 117.108C73.8503 115.581 73.3459 112.624 74.9069 110.503L78.0472 106.235L81.1875 101.968Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9528 111.764L82.8125 116.032C81.2516 118.153 78.2164 118.634 76.0334 117.108C73.8503 115.581 73.3459 112.624 74.9069 110.503L78.0472 106.236L85.9528 111.764Z",
    fill: "#0070CD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 133.5,
    width: 28,
    height: 28,
    rx: 4,
    fill: "#C7DDF7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 140.5,
    width: 46,
    height: 5,
    rx: 2.5,
    fill: "#E3E6EA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 151.5,
    width: 34,
    height: 5,
    rx: 2.5,
    fill: "#E3E6EA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8947 155.5H76.1053C75.4959 155.5 75 155.039 75 154.471V143.5C76.8667 143.5 87.6 143.5 89 143.5V154.471C89 155.039 88.5041 155.5 87.8947 155.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6364 151.5H78.3636C78.1629 151.5 78 151.36 78 151.188V146.812C78 146.64 78.1629 146.5 78.3636 146.5H85.6364C85.8371 146.5 86 146.64 86 146.812V151.188C86 151.36 85.8371 151.5 85.6364 151.5Z",
    fill: "#C7DDF7"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 140.5,
    width: 18,
    height: 3,
    rx: 0.5,
    fill: "#0070CD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5261_46783",
    x: 37,
    y: 30,
    width: 146,
    height: 168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.722656 0 0 0 0 0.821815 0 0 0 0 0.9375 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5261_46783"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5261_46783",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStock);
export default __webpack_public_path__ + "static/media/empty-stock.7d979ae89711bc64c74f1ea622ff95f8.svg";
export { ForwardRef as ReactComponent };